import React, { useRef, useState, useContext } from "react";
import InputField from "../../../lib/ui/inputs/Input";
import AddrDropDown from "../../../lib/ui/dropdown/addressDropDown";
import countriesList from "../../../config/countries.json";
import Button from "../../../ui-styles/controls/button";
import Loader from "../../../lib/ui/loader/Loader";
import DateFnsUtils from '@date-io/date-fns';
import { scan, deleteS3 } from "../../../actions/appointment";
import { OffLineAPI } from "../../../offline-auth/api";
import { updateProfile } from "../../../actions/users";
import { validateLicense } from "../../../lib/validation";
import { RxCross2 } from "react-icons/rx";
import { FiUpload } from "react-icons/fi";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import { toast } from "react-toastify";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

const MedicalCertificate = (props) => {
    const { handleCloseDialog,medicaldata, userId, handleSaveDialog, holdUploadBody, setHoldUploadBody, deleteOnlineOrOfflineFile, formData, setFormData, minDate } = props;
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const [error, setError] = useState({});
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const uploadOnlineOrOffline = (fileName, file) => {
        return new Promise(async (resolve, reject) => {
            let body = {
                uploadtype: file.type,
                size: file.size,
                uploadname: file.name,
            };
            if (process.env.REACT_APP_isOffline === "true") {
                const certifica_data = new FormData();
                certifica_data.append("fileData", file);
                let offlineApiPath = "";
                let urlPath = `${process.env.REACT_APP_api_server}/api/uploads/`;
                try {
                    offlineApiPath = "uploaddoctor";
                    urlPath = `${urlPath}doctorUploads`;
                    const offlineUploadRes = await OffLineAPI.upload("api", offlineApiPath, certifica_data);
                    body = {
                        ...body,
                        url: `${urlPath}/${offlineUploadRes.path}`,
                        uploadkey: offlineUploadRes.path,
                    };
                } catch (error) {
                    console.log("error", error);
                    return reject(error);
                }
            } else {
                try {
                    const certifica_data = new FormData();
                    certifica_data.append("file", file);

                    let params = {
                        bucket: process.env.REACT_APP_s3,
                        fileName: `public/${fileName.replace(/ /g, "_")}`,
                        region: process.env.REACT_APP_s3Region,
                    };

                    let s3UploadRes = await scan(certifica_data, params);

                    if (s3UploadRes && s3UploadRes.status) {
                        s3UploadRes = s3UploadRes.data;
                        body = {
                            ...body,
                            url:
                                `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/` + s3UploadRes.Key,
                            uploadkey: s3UploadRes.Key,
                        };
                    } else {
                        console.log("s3UploadRes.........:)", s3UploadRes);
                        toast.error(s3UploadRes.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        resolve({});

                    }
                } catch (error) {
                    return reject(error);
                }
            }
            return resolve(body);
        });
    };

    const handleUploadFile = async (e) => {
        if (e.target.files.length > 0) {
            const acceptedType = [".jpeg", ".jpg", ".png", ".avif", "doc", ".docx", ".pdf", ".xls", ".xlsx", ".ppt", ".pptx"];
            let file = e.target.files[0];

            const fileAlreadySelected =
                Array.isArray(medicaldata) && medicaldata?.some((f) => f?.fileName?.toLowerCase() === file?.name?.toLowerCase());

            let extension = file.name.split(".").pop();

            if (fileAlreadySelected) {
                toast.dismiss();
                toast.error("File already existed");
                return;
            }

            if (file && !acceptedType.includes(`.${extension}`)) {
                toast.error("Uploaded file format not supported", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else if (file && file.size / (1024 * 1024) < 15) {
                setLoading(true);
                try {
                    let filename = new Date().valueOf() + file.name;
                    filename = "doctorCertifictes/" + filename;
                    try {
                        const fileUploadResBody = await uploadOnlineOrOffline(filename, file);
                        if (Object.keys(fileUploadResBody).length <= 0) {
                            setLoading(false);
                            return;
                        }
                        setLoading(false);
                        setHoldUploadBody(fileUploadResBody);
                        setError({ ...error, upload: "" });
                    } catch (err) {
                        setLoading(false);
                        toast.error(err.errorMessage, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                } catch (e) {
                    setLoading(false);
                    console.log("Error", e);
                }
            } else {
                toast.error("File size should be below 15MB", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } else {
            toast.error("Failed to upload the file", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };
    const handleCancel = async() => {
        await handleRemoveFile()
        handleCloseDialog()
    }
    const handleRemoveFile = async () => {
        if(holdUploadBody.url && holdUploadBody.uploadkey){
            await deleteOnlineOrOfflineFile(holdUploadBody.url, holdUploadBody.uploadkey, holdUploadBody.uploadname);
        }
        setHoldUploadBody({});
    };

    const handleChange = (e) => {
        e.persist();
        setFormData((prevData) => ({
            ...prevData,
            [e.target.name]: e.target.value,
        }));
        setError((prevError) => ({
            ...prevError,
            [e.target.name]: "",
        }));
    };

    const validateForm = () => {
        let _error = {};
        let returnValue = true;
    
        if (formData.license === "") {
            _error["license"] = l.pls_select + " " + l.lic_type;
            returnValue = false;
        }
        if (formData.licenseNo === "" || !validateLicense(formData.licenseNo)) {
            _error["licenseNo"] = l.pls_entr_valid + " " + l.lic_numb;
            returnValue = false;
        }
        if (formData.country === "") {
            _error["country"] = l.pls_sel_country_of + " " + l.license;
            returnValue = false;
        }
        if (
            !formData.expirationDate ||
            isNaN(new Date(formData.expirationDate)) || 
            new Date(formData.expirationDate).valueOf() < minDate.valueOf()
        ) {
            _error["expirationDate"] = "Expiration date must be at least one month from today.";
            returnValue = false;
        }
        if (!holdUploadBody.uploadkey || !holdUploadBody.url) {
            _error["upload"] = "Upload a document";
            returnValue = false;
        }
    
        setError(_error);
        return returnValue;
    };

    
    const handleExpirationDateChange = (date) => {
        const exp_date = date ? date : minDate
        if (exp_date < minDate) {
            setError((prevError) => ({
                ...prevError,
                expirationDate: "Expiration date must be at least one month from today.",
            }));
            setFormData((prevData) => ({
                ...prevData,
                expirationDate: exp_date,
            }));
            return;
        }
    
        setFormData((prevData) => ({
            ...prevData,
            expirationDate: exp_date,
        }));
        setError((prevError) => ({
            ...prevError,
            expirationDate: "",
        }));
    };
    
    const handleIssueDateChange = (date) => {
        const iss_date = date ? date : new Date()
        setFormData((prevData) => ({
            ...prevData,
            issueDate: iss_date.valueOf(),
        }));
        setError((prevError) => ({
            ...prevError,
            issueDate: "",
        }));
    };
    
    
    const handleUploadCertificate = async (e) => {
        try {
            if (validateForm()) {
                setLoading(true);
                let body;
                let newCertificate = {
                    country: formData.country,
                    license: formData.license,
                    licenseNo: formData.licenseNo,
                    url: holdUploadBody.url,
                    key: holdUploadBody.uploadkey,
                    uploadedBy: userId,
                    fileName: holdUploadBody.uploadname,
                    fileType: holdUploadBody.uploadtype,
                    status: "pending",
                    expirationDate: formData.expirationDate.valueOf(),
                    senderName: payload.firstName,
                    createdAt: new Date().valueOf(),
                    updatedAt: new Date().valueOf(),
                    issuedDate: formData.issueDate,
                };
                body = {
                    medicaldocuments: [newCertificate],
                };
                updateProfile(body)
                    .then((res) => {
                        setLoading(false);
                        if (res.status) {
                            setError({});
                            toast.success(l.doc_upd_succ, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            handleSaveDialog();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                        toast.error(err.errorMessage, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    });
            }
        } catch (err) {
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log("Error", err);
        }
    };

    return (
        <div style={{ padding: "10px" }}>
            {loading && <Loader />}
            <div className="flexCol">
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    {l.med_lic}
                    <span className="redTxt">*</span>:
                </span>
                <div className="pdngBtm10">
                    <InputField
                        placeholder={l.med_lic}
                        value={formData.license}
                        name="license"
                        onChange={handleChange}
                        error={error && error.license}
                        errorMsg={error.license}
                        type="text"
                    />
                </div>
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    {l.lic_no}
                    <span className="redTxt">*</span>:
                </span>
                <div className="pdngBtm10">
                    <InputField
                        placeholder={l.lic_no}
                        name="licenseNo"
                        value={formData.licenseNo}
                        onChange={handleChange}
                        error={error && error.licenseNo}
                        errorMsg={error.licenseNo}
                        type="text"
                    />
                </div>
               
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
        Issued Date
        <span className="redTxt">*</span>:
    </span>
    <div className= {error?.issueDate ? "" : "pdngBtm10"}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                fullWidth
                className="pickerInput"
                name="issueDate"
                inputVariant="outlined"
                value={formData.issueDate || new Date()}
                onChange={handleIssueDateChange}
                animateYearScrolling
                placeholderText={l.dob}
                format="dd/MM/yyyy"
                maxDate={new Date()}
            />
        </MuiPickersUtilsProvider>
    </div>
    {error?.issueDate && <span style={{ color: "red", fontSize: "12px", paddingBottom: "10px" }}>{error?.issueDate}</span>}

    <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
        {l.lic_exp_date}
        <span className="redTxt">*</span>:
    </span>
    <div className= {error?.expirationDate ? "" : "pdngBtm10"}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                fullWidth
                className="pickerInput"
                name="expirationDate"
                inputVariant="outlined"
                value={formData.expirationDate}
                onChange={handleExpirationDateChange}
                animateYearScrolling
                placeholderText={l.dob}
                format="dd/MM/yyyy"
                minDate={minDate.valueOf()}
            />
        </MuiPickersUtilsProvider>
    </div>
    {error?.expirationDate && <span style={{ color: "red", fontSize: "12px", paddingBottom: "10px" }}>{error?.expirationDate}</span>}
    
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    {l.select_country}
                    <span className="redTxt">*</span>:
                </span>
                <div className="pdngBtm10">
                    <AddrDropDown
                        items={countriesList}
                        value={formData.country || "India"}
                        name="country"
                        error={error && error.country}
                        errorMsg={error.country}
                        onChange={handleChange}
                    />
                </div>
                <span className="pdngBtm10 smallText" style={{ color: "#6F6F71" }}>
                    {l.upload_certificate}
                    <span className="redTxt">*</span>:
                </span>
                {holdUploadBody.url ? (
                    <div
                        className="flexRow alignCenter"
                        style={{
                            padding: "6px",
                        }}
                    >
                        <span
                            style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#23A4C4",
                                paddingRight: "6px",
                            }}
                        >
                            {holdUploadBody.uploadname}
                        </span>
                        <RxCross2 style={{ cursor: "pointer" }} onClick={handleRemoveFile} />
                    </div>
                ) : (
                    <>
                        <div
                            onClick={handleUploadClick}
                            className="alignCenter justifyCenter brdrRadius cursorPointer"
                            style={{
                                background: "#23A4C41A",
                                height: "75px",
                                width: "90px",
                            }}
                        >
                            <FiUpload style={{ color: "23A4C4", fontSize: "19px" }} />
                            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleUploadFile} />
                        </div>
                        {error?.upload && <span style={{ color: "red", fontSize: "12px" }}>{error?.upload}</span>}
                    </>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", paddingTop: "10px" }}>
                    <Button variant="outlined" size="small" onClick={handleCancel} text={l.cancel} />
                    <Button text={l.save} size="small" variant="contained" style={{ color: "#fff" }} onClick={handleUploadCertificate} />
                </div>
            </div>
        </div>
    );
};

export default MedicalCertificate;
